import { UserUpdatedInterface } from '../interfaces/user-updated.interface';
import { ApiProperty } from '@nestjs/swagger';
import { IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class UserUpdatedDto implements UserUpdatedInterface {
  @ApiProperty({
    format: 'uuid',
    title: 'Updated By User ID',
    description: 'The ID of the user that last updated this record',
  })
  @IsUUID()
  @Expose()
  updatedUserId!: string;
}
